const verifyText = (obj) => {
  const errors = [];
  const regex = /^[a-zA-Z0-9]+$/;
  const regexWithSpaces = /^[a-zA-Z0-9\s]+$/;
  const regexEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

  // Helper para obtener valor con trim (si es string)
  const getTrimmed = (value) =>
    typeof value === "string" ? value.trim() : value;

  // firstname
  const firstname = getTrimmed(obj.firstname);
  if (firstname !== undefined || obj.firstname === "") {
    if (firstname === "") {
      errors.push({ label: "firstname", error: "First name is required." });
    }
    if (firstname !== "" && !regex.test(firstname)) {
      errors.push({
        label: "firstname",
        error: "First name must contain only letters and numbers.",
      });
    }
    if (firstname !== "" && (firstname.length < 3 || firstname.length > 20)) {
      errors.push({
        label: "firstname",
        error: "First name must be between 3 and 20 characters long.",
      });
    }
  }

  // lastname
  const lastname = getTrimmed(obj.lastname);
  if (lastname !== undefined || obj.lastname === "") {
    if (lastname === "") {
      errors.push({ label: "lastname", error: "Last name is required." });
    }
    if (lastname !== "" && !regex.test(lastname)) {
      errors.push({
        label: "lastname",
        error: "Last name must contain only letters and numbers.",
      });
    }
    if (lastname !== "" && (lastname.length < 3 || lastname.length > 20)) {
      errors.push({
        label: "lastname",
        error: "Last name must be between 3 and 20 characters long.",
      });
    }
  }

  // birthday (sin cambios, solo se mantiene la estructura)
  if (obj.birthday || obj.birthday === "") {
    // No se agregan validaciones por ahora
  }

  // username
  const username = getTrimmed(obj.username);
  if (username !== undefined || obj.username === "") {
    if (username === "") {
      errors.push({ label: "username", error: "Username is required." });
    }
    if (username !== "" && (username.length < 3 || username.length > 45)) {
      errors.push({
        label: "username",
        error: "Username must be between 3 and 45 characters long.",
      });
    }
  }

  // roleIdRole
  const roleIdRole = getTrimmed(obj.roleIdRole);
  if (roleIdRole !== undefined || obj.roleIdRole === "") {
    if (roleIdRole === "") {
      errors.push({ label: "roleIdRole", error: "Role is required." });
    }
  }

  // email
  const email = getTrimmed(obj.email);
  if (email !== undefined || obj.email === "") {
    if (email === "") {
      errors.push({ label: "email", error: "Email is required." });
    }
    if (email !== "" && !regexEmail.test(email)) {
      errors.push({
        label: "email",
        error: "Email must be a valid email address.",
      });
    }
    if (email !== "" && (email.length < 3 || email.length > 50)) {
      errors.push({
        label: "email",
        error: "Email must be between 3 and 50 characters long.",
      });
    }
  }

  // groupName
  const groupName = getTrimmed(obj.groupName);
  if (groupName !== undefined || obj.groupName === "") {
    if (groupName === "") {
      errors.push({ label: "groupName", error: "Group name is required." });
    }
    if (groupName !== "" && !regexWithSpaces.test(groupName)) {
      errors.push({
        label: "groupName",
        error: "Group name must contain only letters and numbers.",
      });
    }
    if (groupName !== "" && (groupName.length < 3 || groupName.length > 25)) {
      errors.push({
        label: "groupName",
        error: "Group name must be between 3 and 25 characters long.",
      });
    }
  }

  // name (course name)
  const name = getTrimmed(obj.name);
  if (name !== undefined || obj.name === "") {
    if (name === "") {
      errors.push({ label: "name", error: "Course name is required." });
    }
    if (name !== "" && (name.length < 3 || name.length > 25)) {
      errors.push({
        label: "name",
        error: "Course name must be between 3 and 25 characters long.",
      });
    }
    if (name !== "" && !regexWithSpaces.test(name)) {
      errors.push({
        label: "name",
        error: "Course name must contain only letters and numbers.",
      });
    }
  }

  // Campos que no requieren trim (solo verificación de vacío)
  if (obj.title && obj.title === "") {
    errors.push({ label: "title", error: "Session title is required." });
  }
  if (obj.productIdProduct && obj.productIdProduct === "") {
    errors.push({ label: "productIdProduct", error: "Product is required." });
  }
  if (obj.courseIdCourse && obj.courseIdCourse === "") {
    errors.push({ label: "courseIdCourse", error: "Course is required." });
  }
  if (obj.userIdUser && obj.userIdUser === "") {
    errors.push({ label: "userIdUser", error: "Host is required." });
  }
  if (obj.mode && obj.mode === "") {
    errors.push({ label: "mode", error: "Mode is required." });
  }
  if (obj.dateSession && obj.dateSession === "") {
    errors.push({ label: "dateSession", error: "Date is required." });
  }
  if (obj.faculties && obj.faculties.length === 0) {
    errors.push({
      label: "faculties",
      error: "At least one faculty is required",
    });
  }

  return errors;
};

export default verifyText;
